module.exports = __webpack_public_path__ + "img/icon-device-active.e1b342fa.svg";